module.exports = __webpack_public_path__ + "img/salvar.fd7186ad.svg";